import { DunningState } from '../models';
import { ModelResource } from './resource';

export class DunningStates extends ModelResource<DunningState> {
  model = DunningState;
  resourcePath = 'v1/dunning-states';
}
